
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.532 7.445h0l-4.101-4.508h0l-.005-.004a2.213 2.213 0 00-3.636.797 2.216 2.216 0 00-2.766.3h0c-.23.232-.4.502-.507.79a2.216 2.216 0 00-3.254 1.04L7.471 4.07a2.213 2.213 0 00-3.13 3.13l7.254 7.253-4.161.653h-.001a2.569 2.569 0 00-2.194 2.531c0 .972.79 1.762 1.761 1.762h10.286a6.085 6.085 0 004.331-1.794l1.716-1.716s0 0 0 0a6.075 6.075 0 001.792-4.326 6.108 6.108 0 00-1.593-4.117zm-15.9 8.986h.001l5.471-.86a.671.671 0 00.534-.454h0a.67.67 0 00-.163-.681s0 0 0 0L5.289 6.25a.873.873 0 011.234-1.234l5.458 5.458a.671.671 0 00.948 0h0a.673.673 0 000-.95l-2.23-2.228a.87.87 0 01.007-1.234.87.87 0 011.227 0l2.23 2.23a.67.67 0 00.948 0h0a.673.673 0 00-.001-.95l-1.138-1.137a.87.87 0 01.007-1.234.87.87 0 011.227 0l1.143 1.143.001.001.003.004.01.01.027.026h.006a.67.67 0 00.897-.994l-.089.088.089-.088-.047-.047a.865.865 0 01.005-1.234c.34-.338.888-.335 1.208-.02l4.082 4.486a4.774 4.774 0 011.243 3.215 4.744 4.744 0 01-1.399 3.378l-1.716 1.716a4.752 4.752 0 01-3.383 1.4H7a.42.42 0 01-.42-.42c0-.6.448-1.119 1.052-1.205zm-3.79-6.211h.001a.673.673 0 00.887-.335h0a.672.672 0 00-.335-.888h0a3.7 3.7 0 01-2.18-3.36A3.697 3.697 0 015.91 1.942a3.7 3.7 0 013.36 2.18.67.67 0 101.222-.552A5.043 5.043 0 005.91.601 5.04 5.04 0 00.875 5.636a5.046 5.046 0 002.968 4.584z","fill":"currentColor","stroke":"currentColor","stroke-width":".25"}})])
          )
        }
      }
    